<script setup lang="ts">
  const emit = defineEmits(['hostIsland', 'joinIsland'])
</script>

<template>
  <div class="grid gap-6 md:grid-cols-2">
    <!-- Host Island -->

    <button
      class="corner-squircle group relative flex cursor-pointer flex-col items-center overflow-hidden rounded-3xl border-2 border-green-500/60 bg-[#1c3d38] p-8 text-center transition-transform duration-200 outline-none hover:-translate-y-1"
      @click="emit('hostIsland')"
    >
      <div
        style="background-image: url('/images/wave1.svg')"
        class="motion-safe:group-hover:float-1 wave-blend absolute inset-0 -bottom-48 bg-size-[175%] bg-right bg-repeat-x opacity-25"
      ></div>
      <div class="absolute inset-0 bg-radial from-50% to-black/30"></div>

      <h2 class="font-display mb-2 text-4xl font-bold text-white">Host Island</h2>
      <p class="mb-8 max-w-[40ch] flex-1 text-sm text-green-200">
        Create a Queue for your island that will automatically share your Dodo Code with the right
        visitors
      </p>
      <div class="z-1 items-center justify-center">
        <i-te-host class="size-24" />
      </div>
    </button>

    <!-- Join Island -->
    <button
      class="corner-squircle group relative flex cursor-pointer flex-col items-center overflow-hidden rounded-3xl border-2 border-red-500 bg-[#4a2c2c] p-8 text-center transition-transform duration-200 outline-none hover:-translate-y-1"
      @click="emit('joinIsland')"
    >
      <div
        style="background-image: url('/images/wave2.svg')"
        class="motion-safe:group-hover:float-1 wave-blend absolute inset-0 -bottom-48 bg-size-[175%] bg-right bg-repeat-x opacity-25"
      ></div>
      <div class="absolute inset-0 bg-radial from-50% to-black/30"></div>

      <h2 class="font-display mb-2 text-4xl font-bold text-white">Join Island</h2>
      <p class="mb-8 max-w-[23ch] flex-1 text-sm text-red-200">
        Type in the Host's Turnip Code to view and join their Queue.
      </p>
      <div class="z-1 items-center justify-center">
        <i-te-join class="size-24" />
      </div>
    </button>
  </div>
</template>

<style scoped>
  /* close approximation of the site background color */
  /* this probably should be an svg mask but i dont want to rewrite the background animation for the 5th time */
  /* it'd look something like https://codepen.io/noahblon/pen/PovZva */
  .wave-blend {
    filter: brightness(0.8) sepia(1) hue-rotate(-15deg) saturate(0.85) brightness(0.99);
  }
</style>
